import { type ReactNode } from "react";

import { FirstItemCelebration } from "@/components/_molecules/creation-celebration/first-item-celebration";
import { TableEmptyState } from "@/components/_molecules/table-empty-state/table-empty-state";
import { StoredViewMenuProvider } from "@/domain/view/components/stored-view-menu/stored-view-menu-context";

import {
  type ConfigurationViewConfig,
  DatatableConfigurationView,
} from "./datatable-configuration-view/datatable-configuration-view";
import { DatatableAppliedFilterView } from "./datatable-applied-filter-view";
import { useDatatableContext } from "./use-datatable-context";

interface DatatableShellProps {
  config?: ConfigurationViewConfig;
  children: ReactNode;
}

export function DatatableShell({ config, children }: DatatableShellProps): ReactNode {
  const { rowCount } = useDatatableContext();

  const emptyStateConfig = config?.emptyState;
  const showEmptyState = rowCount === 0 && emptyStateConfig !== undefined;

  return (
    <StoredViewMenuProvider>
      <div className="flex h-full max-h-full w-full flex-col overflow-y-hidden">
        {showEmptyState ? (
          <TableEmptyState {...emptyStateConfig} />
        ) : (
          <>
            <DatatableConfigurationView config={config} />
            <DatatableAppliedFilterView config={config} />
            {children}
          </>
        )}
      </div>
      <FirstItemCelebration itemCount={rowCount} enabled={emptyStateConfig !== undefined} />
    </StoredViewMenuProvider>
  );
}
